import React, { memo, useEffect, useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { FileTextOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { callCenterCallsApi } from '../../utils/api';
import { PANEL_PRIMARY_BTN_CLASS } from '../../constants/ui';

// Text state lives here (not in the parent page) so typing only re-renders this modal,
// not the whole calls table.
const CallReportModal = ({ call, open, onClose, onSaved }) => {
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setText(call?.report || '');
  }, [open, call]);

  const handleSave = async () => {
    if (!call?.id) return;
    setSaving(true);
    try {
      const trimmed = text.trim();
      await callCenterCallsApi.update(call.id, { report: trimmed });
      message.success('گزارش تماس با موفقیت ذخیره شد');
      onSaved?.(call.id, trimmed);
      onClose();
    } catch (error) {
      console.error('خطا در ذخیره گزارش:', error);
      message.error(error?.message || 'خطا در ذخیره گزارش تماس');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={
        <div className="custom-font font-bold flex items-center gap-2">
          <FileTextOutlined className="text-teal-600" />
          <span>ثبت و ویرایش گزارش تماس</span>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="custom-font">
          انصراف
        </Button>,
        <Button
          key="save"
          type="primary"
          className={PANEL_PRIMARY_BTN_CLASS}
          loading={saving}
          onClick={handleSave}
          icon={<CheckCircleOutlined />}
        >
          ذخیره گزارش
        </Button>,
      ]}
      width={500}
      destroyOnClose
    >
      <div className="py-2" style={{ fontFamily: 'CustomFont' }}>
        <p className="text-xs text-gray-500 mb-2">
          گزارش و یادداشت این تماس جهت پیگیری‌های آینده و نمایش در پاپ‌آپ تماس‌های بعدی ذخیره می‌شود:
        </p>
        <Input.TextArea
          rows={5}
          placeholder="شرح مکالمه، توافقات یا نکات مهم را اینجا وارد کنید..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="custom-font text-sm rounded-xl"
          showCount
          maxLength={1000}
        />
      </div>
    </Modal>
  );
};

export default memo(CallReportModal);
